import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Container, Row, Col, Spacer } from '@cleartrip/bento/lib';
import { Swatch, Swatches } from '../../../components/Swatch';
import { Table, TRow, TCol } from '../../../components/Table';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "colours"
    }}>{`Colours`}</h1>
    <p>{`Our color system contains a robust range of tints and shades to build flexible and semantic interfaces`}</p>
    <h2 {...{
      "id": "colors"
    }}>{`Colors`}</h2>
    <div className="flex">
  <Swatch toHref="primary-palette" className="bg-primary-500" mdxType="Swatch" />
  <Spacer mx={2} mdxType="Spacer" />
  <Swatch toHref="secondary-palette" className="bg-secondary-500" mdxType="Swatch" />
  <Spacer mx={2} mdxType="Spacer" />
  <Swatch toHref="tertiary-palette" className="bg-tertiary-500" mdxType="Swatch" />
    </div>
    <Spacer my={2} mdxType="Spacer" />
    <div className="flex">
  <Swatch toHref="success-palette" className="bg-success-500" height="80px" mdxType="Swatch" />
  <Spacer mx={2} mdxType="Spacer" />
  <Swatch toHref="warning-palette" className="bg-warning-500" height="80px" mdxType="Swatch" />
  <Spacer mx={2} mdxType="Spacer" />
  <Swatch toHref="error-palette" className="bg-error-500" height="80px" mdxType="Swatch" />
  <Spacer mx={2} mdxType="Spacer" />
  <Swatch toHref="neutral-palette" className="bg-neutral-500" height="80px" mdxType="Swatch" />
    </div>
    <Spacer my={6} mdxType="Spacer" />
    <h2 {...{
      "id": "primary-palette"
    }}>{`Primary palette`}</h2>
    <Swatches name="primary-0" color="#FEF7EC" dark={true} mdxType="Swatches" />
    <Swatches name="primary-100" color="#FEEED3" dark={true} mdxType="Swatches" />
    <Swatches name="primary-200" color="#FED8A8" dark={true} mdxType="Swatches" />
    <Swatches name="primary-300" color="#FCBD7D" dark={true} mdxType="Swatches" />
    <Swatches name="primary-400" color="#FAA25C" dark={true} mdxType="Swatches" />
    <Swatches name="primary-500" color="#F77728" mdxType="Swatches" />
    <Swatches name="primary-600" color="#D4581D" mdxType="Swatches" />
    <Swatches name="primary-700" color="#B13D14" mdxType="Swatches" />
    <Swatches name="primary-800" color="#8F260C" mdxType="Swatches" />
    <Swatches name="primary-900" color="#761707" mdxType="Swatches" />
    <h2 {...{
      "id": "secondary-palette"
    }}>{`Secondary palette`}</h2>
    <Swatches name="secondary-0" color="#EFF5FC" dark={true} mdxType="Swatches" />
    <Swatches name="secondary-100" color="#D6E8FC" dark={true} mdxType="Swatches" />
    <Swatches name="secondary-200" color="#AECFF9" dark={true} mdxType="Swatches" />
    <Swatches name="secondary-300" color="#83AFEF" dark={true} mdxType="Swatches" />
    <Swatches name="secondary-400" color="#6290E0" dark={true} mdxType="Swatches" />
    <Swatches name="secondary-500" color="#3366CC" mdxType="Swatches" />
    <Swatches name="secondary-600" color="#254EAF" mdxType="Swatches" />
    <Swatches name="secondary-700" color="#193992" mdxType="Swatches" />
    <Swatches name="secondary-800" color="#102776" mdxType="Swatches" />
    <Swatches name="secondary-900" color="#091B61" mdxType="Swatches" />
    <h2 {...{
      "id": "tertiary-palette"
    }}>{`Tertiary palette`}</h2>
    <Swatches name="tertiary-0" color="#E7EFF6" dark={true} mdxType="Swatches" />
    <Swatches name="tertiary-100" color="#E7EFF6" dark={true} mdxType="Swatches" />
    <Swatches name="tertiary-200" color="#D1DFED" dark={true} mdxType="Swatches" />
    <Swatches name="tertiary-300" color="#A6B7C9" dark={true} mdxType="Swatches" />
    <Swatches name="tertiary-400" color="#738294" dark={true} mdxType="Swatches" />
    <Swatches name="tertiary-500" color="#37404E" mdxType="Swatches" />
    <Swatches name="tertiary-600" color="#283143" mdxType="Swatches" />
    <Swatches name="tertiary-700" color="#1B2438" mdxType="Swatches" />
    <Swatches name="tertiary-800" color="#11192D" mdxType="Swatches" />
    <Swatches name="tertiary-900" color="#0A1025" mdxType="Swatches" />
    <h2 {...{
      "id": "success-palette"
    }}>{`Success palette`}</h2>
    <Swatches name="success-0" color="#F8FFEC" dark={true} mdxType="Swatches" />
    <Swatches name="success-100" color="#E9F9D0" dark={true} mdxType="Swatches" />
    <Swatches name="success-200" color="#CFF4A3" dark={true} mdxType="Swatches" />
    <Swatches name="success-300" color="#A5E070" dark={true} mdxType="Swatches" />
    <Swatches name="success-400" color="#7AC149" dark={true} mdxType="Swatches" />
    <Swatches name="success-500" color="#46991A" mdxType="Swatches" />
    <Swatches name="success-600" color="#328313" mdxType="Swatches" />
    <Swatches name="success-700" color="#226E0D" mdxType="Swatches" />
    <Swatches name="success-800" color="#145808" mdxType="Swatches" />
    <Swatches name="success-900" color="#0B4904" mdxType="Swatches" />
    <h2 {...{
      "id": "warning-palette"
    }}>{`Warning palette`}</h2>
    <Swatches name="warning-0" color="#FEF9E5" dark={true} mdxType="Swatches" />
    <Swatches name="warning-100" color="#FEF4CC" dark={true} mdxType="Swatches" />
    <Swatches name="warning-200" color="#FEE699" dark={true} mdxType="Swatches" />
    <Swatches name="warning-300" color="#FED366" dark={true} mdxType="Swatches" />
    <Swatches name="warning-400" color="#FDC140" dark={true} mdxType="Swatches" />
    <Swatches name="warning-500" color="#FCA402" mdxType="Swatches" />
    <Swatches name="warning-600" color="#D88501" mdxType="Swatches" />
    <Swatches name="warning-700" color="#B56801" mdxType="Swatches" />
    <Swatches name="warning-800" color="#924F00" mdxType="Swatches" />
    <Swatches name="warning-900" color="#783D00" mdxType="Swatches" />
    <h2 {...{
      "id": "error-palette"
    }}>{`Error palette`}</h2>
    <Swatches name="error-0" color="#FFF4ED" dark={true} mdxType="Swatches" />
    <Swatches name="error-100" color="#FFE5D4" dark={true} mdxType="Swatches" />
    <Swatches name="error-200" color="#FFC5AA" dark={true} mdxType="Swatches" />
    <Swatches name="error-300" color="#FF9E7F" dark={true} mdxType="Swatches" />
    <Swatches name="error-400" color="#FF7960" dark={true} mdxType="Swatches" />
    <Swatches name="error-500" color="#FF3C2B" mdxType="Swatches" />
    <Swatches name="error-600" color="#DB1F1F" mdxType="Swatches" />
    <Swatches name="error-700" color="#B71523" mdxType="Swatches" />
    <Swatches name="error-800" color="#930D24" mdxType="Swatches" />
    <Swatches name="error-900" color="#7A0824" mdxType="Swatches" />
    <h2 {...{
      "id": "neutral-palette"
    }}>{`Neutral palette`}</h2>
    <Swatches name="neutral-0" color="#F7F7F7" dark={true} mdxType="Swatches" />
    <Swatches name="neutral-100" color="#E6E6E6" dark={true} mdxType="Swatches" />
    <Swatches name="neutral-200" color="#CCCCCC" dark={true} mdxType="Swatches" />
    <Swatches name="neutral-300" color="#B3B3B3" dark={true} mdxType="Swatches" />
    <Swatches name="neutral-400" color="#999999" dark={true} mdxType="Swatches" />
    <Swatches name="neutral-500" color="#808080" mdxType="Swatches" />
    <Swatches name="neutral-600" color="#666666" mdxType="Swatches" />
    <Swatches name="neutral-700" color="#4D4D4D" mdxType="Swatches" />
    <Swatches name="neutral-800" color="#333333" mdxType="Swatches" />
    <Swatches name="neutral-900" color="#1A1A1A" mdxType="Swatches" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      